module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"createAudit":"Yeni Denetim Tarihi Ekle","updateAudit":"Denetim Tarihi Güncelle","title":"Başlık","additionalFiles":"Ek Dosyalar","auditType":"Denetim Tipi","auditDate":"Denetim Tarihi","branch":"Denetim Yapılacak Lokasyon"},"en":{"createAudit":"Add New Audit Date","updateAudit":"Update Audit Date","title":"Title","additionalFiles":"Additional Files","auditType":"Audit Type","auditDate":"Audit Date","branch":"Locations for Audit"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/modals/CreateAudit.vue
// module id = pbXn
// module chunks = 1